import axios from 'axios';
import { useEffect } from 'react';
import { useAuth } from '../context/AuthProvider';

export const BASE_URL = 'https://cup.wirmodiscgolf.fi';

/*
const auth = () => { 
        let data = localStorage.getItem('userData'); 
        return data ? JSON.parse(data) : {};
    
    };
*/

const api = axios.create({
    baseURL: BASE_URL,
});

let currentAuth = null;
let currentSetAuth = null;
let refreshPromise = null;

const getStoredAccessToken = () => {
  try {
    const storedData = localStorage.getItem('userData');

    if (!storedData) {
      return null;
    }

    const parsedData = JSON.parse(storedData);
    const storedToken = parsedData?.accessToken;

    return typeof storedToken === 'string' && storedToken.trim() !== ''
      ? storedToken
      : null;
  } catch {
    return null;
  }
};

const refreshAccessToken = async () => {
  try {
    const response = await api.post('/refresh.php', {}, {
      withCredentials: true,
      _skipAuthRefresh: true,
    });

    return response?.data?.token ?? response?.data?.accessToken ?? null;
  } catch (error) {
    console.error('Refresh Token Failed', error);
    return null;
  }
};

api.interceptors.request.use(
  (config) => {
    const nextConfig = config;
    nextConfig.headers = nextConfig.headers ?? {};

    const method = String(nextConfig.method || '').toLowerCase();
    const token = currentAuth?.accessToken || getStoredAccessToken();

    if (method === 'post') {
      nextConfig.headers['Content-Type'] = 'application/json;charset=utf-8';
      nextConfig.headers['Referrer-Policy'] = 'no-referrer';
    }

    if (token && !nextConfig.headers['X-Auth-Token']) {
      nextConfig.headers['X-Auth-Token'] = token;
    }

    return nextConfig;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config ?? {};
    const originalUrl = String(originalRequest?.url || '');
    const isRefreshRequest = originalUrl.includes('/refresh.php');
    const isLoginRequest = originalUrl.startsWith('login') || originalUrl.includes('/login.php');

    if (
      error?.response?.status === 401
      && !originalRequest._retry
      && !isRefreshRequest
      && !isLoginRequest
      && !originalRequest._skipAuthRefresh
    ) {
      originalRequest._retry = true;

      if (!refreshPromise) {
        refreshPromise = refreshAccessToken().finally(() => {
          refreshPromise = null;
        });
      }

      const newAccessToken = await refreshPromise;

      if (newAccessToken) {
        if (typeof currentSetAuth === 'function') {
          currentSetAuth((prev) => ({
            ...prev,
            accessToken: newAccessToken,
          }));
        }

        originalRequest.headers = originalRequest.headers ?? {};
        originalRequest.headers['X-Auth-Token'] = newAccessToken;

        return api(originalRequest);
      }

      if (typeof currentSetAuth === 'function') {
        currentSetAuth({});
      }
    }

    return Promise.reject(error);
  }
);

const useAxios = () => {
  const { auth, setAuth } = useAuth();

  currentAuth = auth;
  currentSetAuth = setAuth;

  useEffect(() => {
    currentAuth = auth;
    currentSetAuth = setAuth;
  }, [auth, setAuth]);

  return api;
};

export default useAxios;

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json'},
    withCredentials: true    
});